var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 160,
        width: 500,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "32",
          y: "10",
          rx: "0",
          ry: "0",
          width: "120",
          height: "13",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "32",
          y: "30",
          rx: "0",
          ry: "0",
          width: "220",
          height: "15",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "32",
          y: "50",
          rx: "0",
          ry: "0",
          width: "220",
          height: "15",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "32",
          y: "70",
          rx: "0",
          ry: "0",
          width: "220",
          height: "15",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "410", cy: "10", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "450", cy: "10", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "410", cy: "30", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "450", cy: "30", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "410", cy: "50", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "450", cy: "50", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "410", cy: "70", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "450", cy: "70", r: "8" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }